import {ConfirmModalData} from '../core/ui/confirm-modal/confirm-modal.component';

export const DELETE_RESOURCE_MESSAGE: ConfirmModalData = {
    title: `Delete :resource`,
    body:  `Are you sure you want to delete selected :resource?`,
    ok:    'Delete'
};
